
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent-resources/change-password",
      function () {
        return require("private-next-pages/agent-resources/change-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent-resources/change-password"])
      });
    }
  